// **** colaboradores servicos ****
// **** p_colaboradores_servicos.jsx ****
// **** autor: Walcledson de Paula ****
// **** 15-08-24 | 00h17 ****
// **** alterações: 18/8/24w | 10h53 *******
// **** atualizações 27/8/24w | 12h13 ****
// **** atualizações 20/10/24w | 13h36 | correção bugs  ****




import { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';
import Swal from "sweetalert2";
import { Oval } from "react-loader-spinner";
import Icon from '@mdi/react'; // icone do material design icones pra padronizar o home do mobile/desktop (delphi) no web 2/7/24w
import { mdiInvoiceTextClockOutline, mdiAccountMultiple } from '@mdi/js'; // novo // alterar
import apiaxios from "../../../../../Services/apiaxios.js";
import handleApiError from "../../../../../Services/apiErrorHandler.js";
import { decrypt } from "../../../../../Services/cryptoUtils.js";
import { p_getUserData } from "../../../../../Services/p_userutils.js";
import { AutoLogout } from "../../../../../Services/autologout.js";

import Menu from '../../../Components/Menu/p_menu.jsx';
import Footer from "../../../../AgendexCliente/components/Footer/footer.jsx";
import MultiSelect from 'react-select';

import './p_colaboradores_servicos.css';

function ColaboradoresServicos() {
//     const tokenASW = localStorage.getItem("tokenasw");
    const tokenASW = decrypt(localStorage.getItem('tokenasw'));
    const tokenlg = localStorage.getItem("tokenlg");

    useEffect(() => {
        if (!tokenASW || !tokenlg) {
            console.error('token adulterado');
            AutoLogout();
        }
    }, [tokenASW, tokenlg]);

    const initialUserData = p_getUserData();
    const [userId, setUserId] = useState(initialUserData.userId); // id_usuario logado 23/9/24w

    const [loading, setLoading] = useState(false);
    const [colaboradores, setColaboradores] = useState([]);
    const [colaborador, setColaborador] = useState(null);
    const [servicos, setServicos] = useState([]);
    const [colaboradorservicos, setColaboradorServicos] = useState([]);
    const [nenhumServicoEncontrado, setNenhumServicoEncontrado] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        loadColaboradores();

    }, [userId]);

    const loadColaboradores = async () => {
        if (userId) {
            try {
                const empresaColaboradores = await fetchColaboradores(userId);
                    setColaboradores(empresaColaboradores);
            } catch (error) {
                console.error('Erro ao buscar colaboradores:', error);
            }
        }
    };

    const fetchColaboradores = async (id_empresa) => {
        try {
            setLoading(true);
//             const colaboradoresResponse = await apiaxios.get(`/empresa/colaboradorWeb?id_empresa=${id_empresa}&id_usuario=${id_empresa}&token=${tokenASW}`); // modificado pela linha abaixo 20/10/24w12h26
            const colaboradoresResponse = await apiaxios.get(`/colaborador/listarWeb?id_empresa=${id_empresa}&id_usuario=${id_empresa}&token=${tokenASW}`);
            if (colaboradoresResponse.status === 200 && colaboradoresResponse.data.length > 0) {
                return colaboradoresResponse.data;
            } else {
                setNenhumServicoEncontrado(true);
                return [];
            }
        } catch (error) {
            handleApiError(error);
            return [];
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        loadServicos();
    }, [userId]);

    const loadServicos = async () => {
        if (userId) {
            try {
                const empresaServicos = await fetchServicos(userId);
                    setServicos(empresaServicos);
                } catch (error) {
                    console.error('Erro ao buscar serviços: ', error);
                }
        }
    };
    
    const fetchServicos = async (id_empresa) => {
        try {
            setLoading(true);
//             const servicosResponse = await apiaxios.get(`/servico/listar?id_empresa=${id_empresa}&id_usuario=${id_empresa}&token=${tokenASW}`); // modificado pela linha abaixo 20/10/24w12h27
            const servicosResponse = await apiaxios.get(`/servico/listarWeb?id_empresa=${id_empresa}&id_usuario=${id_empresa}&token=${tokenASW}`);
            if (servicosResponse.status === 200 && servicosResponse.data.length > 0) {
                setNenhumServicoEncontrado(false);
                return servicosResponse.data.map((servico) => ({ label: servico.DESCRICAO, value: servico.ID_SERVICO }));
            } else {
                setNenhumServicoEncontrado(true);
                return [];
            }
        } catch (error) {
            handleApiError(error);
            setNenhumServicoEncontrado(true);
            return [];
        } finally {
            setLoading(false);
        }
    };

    const fetchColaboradorServicos = async (id_colaborador) => {
        try {
            setLoading(true);
            const response = await apiaxios.get(`/empresa/colaboradorServicoWeb`, {
                params: { id_colaborador,
                        id_usuario: userId,
                        token: tokenASW
                }
            });
    
            if (response.status === 200 && Array.isArray(response.data) && response.data.length > 0) {
                setNenhumServicoEncontrado(false);
                setColaboradorServicos(response.data);
                // console.log('FETCH colaborador servicos > response.data: ', response.data);
            } else {
                Swal.fire('Erro', 'Nenhum serviço encontrado para este colaborador.', 'error');
                setNenhumServicoEncontrado(true);
            }
        } catch (error) {
            handleApiError(error);
            setNenhumServicoEncontrado(true);
        } finally {
            setLoading(false);
        }
    };
    
    const handleExcluir = (id_servico) => {
        Swal.fire({
            title: 'Confirmação',
            text: `Confirma a remoção do Serviço id #${id_servico} do Colaborador id #${colaborador} ?`,
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sim, excluir!',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.isConfirmed) {
                fetchExcluirColaboradorServico(colaborador, id_servico);
            }
        });
    };

    const fetchExcluirColaboradorServico = async (id_colaborador, id_servico) => {
        setLoading(true);
        try {
            const response = await apiaxios.delete('empresa/colaboradorServicoWeb', {
                params: { id_colaborador, id_servico, id_usuario: userId, token: tokenASW }
            });
            if (response.status === 200 && response.data.retorno === 'OK') {
                Swal.fire('Informação', 'Serviço removido com sucesso!', 'success');
                setColaboradorServicos((prevServicos) => {
                    // const updatedServicos = prevServicos.filter((servico) => servico.ID_SERVICO !== id_servico);
                    const updatedServicos = prevServicos.filter((servico) => servico.COS_ID !== id_servico);
                    // console.log('Updated Services:', updatedServicos);  // Verifique o estado atualizado
                    // console.log('servico ID SERVICO :', id_servico);
                    // console.log('colaboradoresServicos :', colaboradorservicos);
                    // console.log('prevServicos :', prevServicos);
                        return updatedServicos;
                });

//                 setColaboradorServicos((prevServicos) => prevServicos.filter((servico) => servico.ID_SERVICO !== id_servico));
//                 setColaboradorServicos((prevServicos) => prevServicos.filter((servico) => servico.id_servico !== id_servico));
                // loadServicos();
            } else {
                Swal.fire('Erro', response.data.retorno || 'Falha ao remover o Serviço. Tente novamente mais tarde.', 'error');
            }
        } catch (error) {
            handleApiError(error);
        } finally {
            setLoading(false);
        }
    };  

    const handleAddService = async (selectedServices) => {
        // // Atualiza o estado dos serviços selecionados
        // setColaboradorServicos(selectedServices);
        console.log('selectedServices ', selectedServices);

        // Verificar se selectedServices é um array ou um único objeto
        const servicesArray = Array.isArray(selectedServices) ? selectedServices : [selectedServices];

        // // Atualizar o estado com os serviços selecionados
        // setColaboradorServicos(servicesArray);

        if (servicesArray.length === 0) return; // Não faça nada se o usuário não selecionar nenhum serviço

        Swal.fire({
            title: 'Confirmação',
            text: 'Deseja incluir o(s) serviço(s) selecionado(s) para o colaborador?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sim, incluir!',
            cancelButtonText: 'Cancelar'
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    // console.log('servicesArray:', servicesArray);
                    // console.log('id_colaborador :', colaborador);

                    setLoading(true);

                    // Mapeia e envia os serviços para o servidor
                    const requests = servicesArray.map((servico) => {
                        return apiaxios.post('/empresa/colaboradorServicoWeb', {
                            id_colaborador: colaborador,
                            id_servico: servico.value
                        },
                        { 
                            params: {
                                id_usuario: userId,
                                token: tokenASW
                            }
                        })
                    });

                    // Aguarda todas as requisições serem completadas
                    await Promise.all(requests);

                    Swal.fire('Informação', 'Serviço(s) incluído(s) com sucesso!', 'success');

                    // Recarrega a lista de serviços do colaborador após a inclusão
                    // const colaboradorServicos = await fetchColaboradorServicos(colaborador);
                    // setColaboradorServicos(colaboradorServicos);

                    // Atualiza a lista de serviços localmente com os novos serviços
                    const newServices = servicesArray.map(servico => ({
                        COS_ID: Math.random(), // Substitua por um ID correto se necessário
                        COL_ID: colaborador,
                        SER_ID: servico.value,
                        SER_DESCRICAO: servico.label, // Adapte conforme a sua estrutura de dados
                        SER_DURACAO: '00:00:00', // Adapte conforme necessário
                    }));

                    setColaboradorServicos((prevServicos) => [...prevServicos, ...newServices]);

                } catch (error) {
                    // console.log('Erro capturado:', error);
                    // alert('Erro ao incluir serviços');
                    handleApiError(error);
                } finally {
                    setLoading(false);
                }
            }
        });
    };

    const handleHorarios = () => {
        navigate('/app/prestador/empresa/colaboradores/horarios');
    };

    const handleColaboradores = () => {
        navigate('/app/prestador/empresa/colaboradores');
    };




    return <>
        <div className="p_colaboradores_servicos">
            <div className="container-fluid">
                <div className="row flex-nowrap">
                    <div className="col-auto col-md-3 col-xl-2 px-sm-2 px-0">
                        <Menu page="colaboradores" />
                    </div>
                    <div className="col py-2 me-3">
                        <div className="container-fluid">
                            <h1 className="text-center">Serviços por Colaborador</h1>
                            <hr />
                            <div className="text-right">
                                <button type='button' className="btn btn-info m-2" onClick={() => handleHorarios()}>
                                    <Icon path={mdiInvoiceTextClockOutline } size={1} className="me-2"/>Horários
                                </button>
                                <button type='button' className="btn btn-info m-2" onClick={() => handleColaboradores()}>
                                    <Icon path={mdiAccountMultiple } size={1} className="me-2"/>Colaboradores
                                </button>
                            </div>
                            {/* <div className="form-group">
                                <label htmlFor="colaborador">Selecione o Colaborador:</label>
                                <select className="form-control" id="colaborador" onChange={e => {
                                    const selectedColaborador = e.target.value;
                                    setColaborador(selectedColaborador);
                                    fetchColaboradorServicos(selectedColaborador);
                                    }} value={colaborador || ''}>
                                        <option value="" disabled>Selecione...</option>
                                        {colaboradores.map(colab => (
                                            <option key={colab.COL_ID} value={colab.COL_ID}>
                                                {colab.COL_NOME}
                                            </option>
                                    ))}
                                </select>
                                <div className="form-group">
                                    <label htmlFor="servicos">Serviços:</label>
                                    <MultiSelect
                                        options={servicos}
                                        value={colaboradorservicos.map(servico => ({ label: servico.SER_DESCRICAO, value: servico.COS_ID }))}
                                        // value={colaboradorservicos.map(servico => ({ label: servico.SER_DESCRICAO, value: servico.SER_ID }))}
                                        onChange={handleAddService}
                                        labelledBy="Selecione os Serviços"
                                        className="multi-select"
                                    />
                                </div>
                                {loading && <div className="loading-spinner-container">
                                    <Oval
                                        height={50}
                                        width={50}
                                        color="#007bff"
                                        ariaLabel="oval-loading"
                                        secondaryColor="#007bff"
                                        strokeWidth={2}
                                        strokeWidthSecondary={2}
                                    />
                                </div>}
                                {!loading && nenhumServicoEncontrado && <div className="alert alert-warning mt-2">Nenhum serviço encontrado para o colaborador selecionado.</div>}
                                <div className="mt-4">
                                    <h2>Serviços atribuídos:</h2>
                                    <ul className="list-group">
                                        {colaboradorservicos.map(servico => (
                                            // <li key={servico.COS_ID} className="list-group-item d-flex justify-content-between align-items-center">
                                            <li key={servico.SER_ID} className="list-group-item d-flex justify-content-between align-items-center">
                                            <span className="">
                                                    {servico.SER_DESCRICAO}
                                                </span>
                                                <button 
                                                    className="btn btn-danger btn-sm mt-2ms-auto text-nowrap"
                                                    // style={{ whiteSpace: 'nowrap' }}
                                                    onClick={() => handleExcluir(servico.COS_ID)}
                                                >
                                                    <i className="bi bi-trash-fill me-2"></i>Remover
                                                </button>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div> */}
                            <div className="form-group">
                                <label htmlFor="colaborador">Selecione o Colaborador:</label>
                                <select 
                                    className="form-control" 
                                    id="colaborador" 
                                    onChange={e => {
                                        const selectedColaborador = e.target.value;
                                        setColaborador(selectedColaborador);
                                        fetchColaboradorServicos(selectedColaborador);
                                    }} 
                                    value={colaborador || ''}
                                >
                                    <option value="" disabled>Selecione...</option>
                                    {colaboradores.map(colab => (
                                        <option key={colab.COL_ID} value={colab.COL_ID}>
                                            {colab.COL_NOME}
                                        </option>
                                    ))}
                                </select>

                                <div className="form-group">
                                    <label htmlFor="servicos">Serviços:</label>

                                    <MultiSelect
                                        options={servicos} // Aqui são os serviços disponíveis, que têm um 'label' e um 'value'
                                        // {(console.log('colabordoresservicos dentro de multiselect ', colaboradorservicos))}

                                        // value={colaboradorservicos.map(servico => ({
                                        //     label: servicos.find(s => s.value === servico.SER_ID)?.label || servico.SER_DESCRICAO, // Ajustando para pegar o label correto
                                        //     value: servico.SER_ID  // Usando SER_ID como o identificador real
                                        // }))}

                                        // value={colaboradorservicos.map(servico => {
                                        //     const label = servicos.find(s => s.value === servico.SER_ID)?.label || servico.SER_DESCRICAO;
                                        //     const value = servico.SER_ID;
                            
                                        //     // Adiciona console.log para visualizar o que está sendo mapeado
                                        //     console.log("Mapeando serviço:", { label, value });
                            
                                        //     return { label, value };
                                        // })}
                                        value={colaboradorservicos.map(servico => ({ label: servico.SER_DESCRICAO, value: servico.SER_ID }))}

                                        onChange={handleAddService}
                                        labelledBy="Selecione os Serviços"
                                        className="multi-select"
                                    />
                                </div>

                                {loading && (
                                    <div className="loading-spinner-container">
                                        <Oval
                                            height={50}
                                            width={50}
                                            color="#007bff"
                                            ariaLabel="oval-loading"
                                            secondaryColor="#007bff"
                                            strokeWidth={2}
                                            strokeWidthSecondary={2}
                                        />
                                    </div>
                                )}

                                {!loading && nenhumServicoEncontrado && (
                                    <div className="alert alert-warning mt-2">
                                        Nenhum serviço encontrado para o colaborador selecionado.
                                    </div>
                                )}

                                <div className="mt-4">
                                    <h2>Serviços atribuídos:</h2>
                                    <ul className="list-group">
                                        {colaboradorservicos.map(servico => (
                                            <li key={servico.COS_ID} className="list-group-item d-flex justify-content-between align-items-center">
                                                <span>{servico.SER_DESCRICAO}</span>
                                                <button 
                                                    className="btn btn-danger btn-sm mt-2 ms-auto text-nowrap"
                                                    onClick={() => handleExcluir(servico.COS_ID)}
                                                >
                                                    <i className="bi bi-trash-fill me-2"></i>Remover
                                                </button>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    </>;
}

export default ColaboradoresServicos;